<div class="main no-padding">
  <header-menu></header-menu>

  <div class="center-content internal-registration-establishment fade-in-animation">
    <div class="card area-to-overlay ">
      <div class="card-content">

        <h1 class="no-margin">Galeria e Logotipo</h1>

        <!-- LOGO -->
        <div class="header-gallery">
          <h2>Logotipo</h2>
          <p>Com o logo seu negócio se torna reconhecível instataneamente para seus clientes.</p>
        </div>
        <div class="row">
          <div class="col-xs-12 col-md-4">
            <div class="item logo-box" *ngIf="!establishment['image']['logo']" (click)="crop.setImage()">
              <i class="fa fa-image"></i>
            </div>
        
            <div class="item logo-box" *ngIf="establishment['image']['logo']">
              <img [src]="establishment.image.logo">
            </div>
        
            <image-cropper #crop (cropEvent)="getImageLogo($event)" [imageHeight]="200"></image-cropper>
                  
          </div>
        </div>

        <div class="row">
          <div class="col-xs-12" *ngIf="!establishment.image.logo">
            <a href="https://google.com/search?tbm=isch&q={{ establishment['name'] }}+logo" target="_blank">{{ 'REGISTRATION.LOGO.SEARCH_LOGO_IMAGE_LABEL' | translate }}</a>
          </div>
        
          <div class="col-xs-12" *ngIf="establishment.image.logo && !isLoading">
            <a (click)="clearLogoImage()"> {{ 'REGISTRATION.LOGO.CLEAR_IMAGE' | translate }}</a>
          </div>
        </div>

        <!-- Cover -->
        <div class="header-gallery">
          <h2>Capa</h2>
          <p>A capa é a imagem de destaque do seu negócio.</p>
        </div>
        <div class="row">
          <div class="col-xs-12 col-md-4">
            <div class="item-cover cover-box" *ngIf="!establishment['image']['cover']" (click)="cropCover.setImage()">
              <i class="fa fa-image"></i>
            </div>
        
            <div class="item-cover cover-box" *ngIf="establishment['image']['cover']">
              <img [src]="establishment.image.cover" width="200px" height="200px">
            </div>
        
            <image-cropper #cropCover (cropEvent)="getImageCover($event)" [imageWidth]="1280" [imageHeight]="800"></image-cropper>
                  
          </div>
        </div>
        
        <div class="row">
          <div class="col-xs-12" *ngIf="establishment.image.cover && !isLoading">
            <a (click)="clearCoverImage()"> {{ 'REGISTRATION.COVER.CLEAR_IMAGE' | translate }}</a>
          </div>
        </div>
        <!-- / Cover -->

        <!-- Gallery -->
        <div class="header-gallery">
          <h2>Galeria</h2>
          <p>Fotos de alta qualidade aumentam a visibilidade do seu estabelecimento na plataforma. As fotos devem ter ao menos 500x500 pixels e no máximo 1MB.</p>
        </div>
        <div class="row">
          <div class="col-xs-12 establishment-gallery-registration-internal">

            <div class="row">
              <div class="col-md-3 picture">

                <div class="item" *ngIf="!establishment['image']['gallery']['images'][0]" (click)="cropGallery1.setImage()">
                  <i class="fa fa-image"></i>
                </div>
                <div class="item" *ngIf="establishment['image']['gallery']['images'][0]">
                  <img [src]="establishment['image']['gallery']['images'][0]">
                </div>
                
                <image-cropper #cropGallery1 (cropEvent)="getImageGallery($event, 0)" [imageWidth]="200" [imageHeight]="200"></image-cropper>
                
                <div class="row">
                  <div class="col-xs-12" *ngIf="establishment['image']['gallery']['images'][0] && !isLoading">
                    <a (click)="clearImageGallery(0)"> {{ 'REGISTRATION.GALLERY.CLEAR_IMAGE' | translate }}</a>
                  </div>
                </div>
              </div>
        
              <div class="col-md-3 picture">

                <div class="item" *ngIf="!establishment['image']['gallery']['images'][1]" (click)="cropGallery2.setImage()">
                  <i class="fa fa-image"></i>
                </div>
                <div class="item" *ngIf="establishment['image']['gallery']['images'][1]">
                  <img [src]="establishment['image']['gallery']['images'][1]">
                </div>
                
                <image-cropper #cropGallery2 (cropEvent)="getImageGallery($event, 1)" [imageWidth]="200" [imageHeight]="200"></image-cropper>
                
                <div class="row">
                  <div class="col-xs-12" *ngIf="establishment['image']['gallery']['images'][1] && !isLoading">
                    <a (click)="clearImageGallery(1)"> {{ 'REGISTRATION.GALLERY.CLEAR_IMAGE' | translate }}</a>
                  </div>
                </div>
              </div>
        
              <div class="col-md-3 picture">

                <div class="item" *ngIf="!establishment['image']['gallery']['images'][2]" (click)="cropGallery3.setImage()">
                  <i class="fa fa-image"></i>
                </div>
                <div class="item" *ngIf="establishment['image']['gallery']['images'][2]">
                  <img [src]="establishment['image']['gallery']['images'][2]">
                </div>

                <image-cropper #cropGallery3 (cropEvent)="getImageGallery($event, 2)" [imageWidth]="200" [imageHeight]="200"></image-cropper>
                
                <div class="row">
                  <div class="col-xs-12" *ngIf="establishment['image']['gallery']['images'][2] && !isLoading">
                    <a (click)="clearImageGallery(2)"> {{ 'REGISTRATION.GALLERY.CLEAR_IMAGE' | translate }}</a>
                  </div>
                </div>
              </div>
        
              <div class="col-md-3 picture">

                <div class="item" *ngIf="!establishment['image']['gallery']['images'][3]" (click)="cropGallery4.setImage()">
                  <i class="fa fa-image"></i>
                </div>
                <div class="item" *ngIf="establishment['image']['gallery']['images'][3]">
                  <img [src]="establishment['image']['gallery']['images'][3]">
                </div>
                
                <image-cropper #cropGallery4 (cropEvent)="getImageGallery($event, 3)" [imageWidth]="200" [imageHeight]="200"></image-cropper>
                
                <div class="row">
                  <div class="col-xs-12" *ngIf="establishment['image']['gallery']['images'][3] && !isLoading">
                    <a (click)="clearImageGallery(3)"> {{ 'REGISTRATION.GALLERY.CLEAR_IMAGE' | translate }}</a>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
        <!-- / Gallery -->

        <div class="loading-overlay" *ngIf="isLoading">
          <div class="loader-wrp">
            <div class="loader"><span></span><span></span><span></span></div>
            <p> {{ 'LOADING' | translate }}</p>
          </div>
        </div>

      </div>
    </div>
  </div>

</div>
